var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Multiship" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "multiship-main-content" },
        [
          _c("div", { staticClass: "multiship-content" }, [
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "how-ship" }, [
              _c("p", { staticClass: "subtitle" }, [
                _vm._v("NOTE: The page will reload.")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "toggles-container" }, [
                _c("div", { staticClass: "toggle-container" }, [
                  _c("p", [_vm._v("Ship to multiple addresses")]),
                  _vm._v(" "),
                  _c("label", { staticClass: "switch" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.multishipChecked,
                          expression: "multishipChecked"
                        }
                      ],
                      attrs: { disabled: _vm.isProcessing, type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.multishipChecked)
                          ? _vm._i(_vm.multishipChecked, null) > -1
                          : _vm.multishipChecked
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.multishipChecked,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.multishipChecked = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.multishipChecked = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.multishipChecked = $$c
                            }
                          },
                          function($event) {
                            return _vm.changeShipping(true)
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "slider round" })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "toggle-container" }, [
                  _c("p", [_vm._v("Ship all boxes to one address")]),
                  _vm._v(" "),
                  _c("label", { staticClass: "switch" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.singleCheckoutChecked,
                          expression: "singleCheckoutChecked"
                        }
                      ],
                      attrs: { disabled: _vm.isProcessing, type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.singleCheckoutChecked)
                          ? _vm._i(_vm.singleCheckoutChecked, null) > -1
                          : _vm.singleCheckoutChecked
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.singleCheckoutChecked,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.singleCheckoutChecked = $$a.concat([
                                    $$v
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.singleCheckoutChecked = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.singleCheckoutChecked = $$c
                            }
                          },
                          function($event) {
                            return _vm.changeShipping(false)
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "slider round" })
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "boxes-container" },
              _vm._l(_vm.lineItems, function(item, i) {
                return _c("CartItem", {
                  key: item.key,
                  attrs: {
                    cartItem: item,
                    position: i,
                    formData: _vm.formData
                  },
                  on: { openform: _vm.openForm }
                })
              }),
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "footer-checkout" }, [
              _c(
                "button",
                {
                  staticClass: "happybox-button yellow",
                  class: _vm.isLoading ? "isLoading" : "",
                  attrs: { disabled: !_vm.canSubmit },
                  on: { click: _vm.multishipCheckout }
                },
                [_vm._v(_vm._s(_vm.buttonText))]
              )
            ])
          ]),
          _vm._v(" "),
          _c("Summary", {
            attrs: { isLoading: _vm.isLoading, canSubmit: _vm.canSubmit }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.currentItem && _vm.formIsOpen
        ? _c("EmailModal", {
            attrs: { product: _vm.currentItem },
            on: { close: _vm.closeForm, end: _vm.updateModalInfo }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isProcessing
        ? _c("div", { staticClass: "spinner-container" }, [
            _c("div", { staticClass: "spinner" })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/shipping_header.svg?v=1657813497"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "main-title" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_5257b419-6ffa-4278-bd91-46864bc15443.svg?v=1656613004"
        }
      }),
      _vm._v("You're so close! Confirm shipping options below "),
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_5257b419-6ffa-4278-bd91-46864bc15443.svg?v=1656613004"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert-banner" }, [
      _c("p", { staticClass: "main-copy" }, [
        _vm._v("Note: The recipient must redeem the gift inside the US")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }